import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import {
  OperationalVehicleGPSCollection,
  OperationalVehiclesCollection,
} from "features/VehicleSidebar/VehicleList/AlternativeTransportList/AlternativeTransportList";

export const useVyatData = () => {
  const { data: vyAtData, isError: isErrorVyAt } = useQuery({
    queryKey: ["vyat"],
    refetchInterval: 30000,
    queryFn: async ({ signal }) =>
      queryFnGET<OperationalVehiclesCollection>({
        signal,
        url: `${getBackendUrl()}/bus/operational-vehicles/NO`,
      }),
  });

  return { vyAtData, isErrorVyAt };
};

export const useVyatDataGPS = () => {
  const { data: vyAtData, isError: isErrorGPS } = useQuery({
    queryKey: ["vyat"],
    refetchInterval: 30000,
    queryFn: async ({ signal }) =>
      queryFnGET<OperationalVehicleGPSCollection>({
        signal,
        url: `${getBackendUrl()}/bus/operational-vehicles/gps/NO`,
      }),
  });

  return { vyAtData, isError: isErrorGPS };
};
